const storage = localStorage;

export const setDataInBrowser = (key, value) => {
  storage.setItem(key, JSON.stringify(value));
};

export const getDataFromBrowser = (key) => {
  const item = storage.getItem(key);
  return item ? JSON.parse(item) : null;
};

export const removeDataFromBrowser = (key) => {
  storage.removeItem(key);
};

export const setStringInBrowser = (key, value) => {
  storage.setItem(key, value);
};

export const getStringFromBrowser = (key) => {
  return storage.getItem(key);
};